// Common State.
const defaults = {
  stateLoading: false
};

export default {
  state: Object.assign({}, defaults),

  mutations: {
    showLoading(state, options) {
      state.stateLoading = options;
    }
  },

  actions: {
    SHOWLOADING({ commit }, options) {
      commit('showLoading', options);
    }
  }
};
